export class Invoice {
    invoiceid: number;
    vendorid: number;
    invoicedate: Date;
    invoiceduedate: Date;
    purpose: string;
    invoiceno: string;
	vendorinvoiceno: string;
    poreference: string;
	ponumber:string;
    invoicepath: string;
    itemcount: number;
    totalamount: number; 
    totalgst: number;
    grandtotal: number;
    invoicestatus: number;
    paymentmode: number;
    paymentdate: Date;
	vendorname:string;
	vendoraddress:string;
	vendormailid:string;
	poamount:number;
	vendorphone:number;
    poitem:Array<any>;
	isdeleted: number;
	currencyid: number;
    // active: number;
	
}